import PropTypes from "prop-types";
import React, { useState } from "react";
import { validateAttributes, errorMessage } from "../../utils/validations";
import { validations } from "./validations";

const HeadAdminModal = (props) => {
  const { headAdmin, headAdmins, setHeadAdmins, setShowHeadAdminModal } = props;
  const isEditMode = headAdmin !== undefined;

  const [firstName, setFirstName] = useState(
    isEditMode ? headAdmin.name.split(" ")[0] : "",
  );
  const [lastName, setLastName] = useState(
    isEditMode ? headAdmin.name.split(" ")[1] : "",
  );
  const [email, setEmail] = useState(isEditMode ? headAdmin.email : "");
  const [errors, setErrors] = useState({});
  const label = isEditMode ? "Edytuj Head Admina" : "Dodaj Head Admina";

  const postHeadAdmin = async () => {
    const response = await fetch("/head_admins", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
      },
      body: JSON.stringify({
        head_admin: {
          first_name: firstName,
          last_name: lastName,
          email: email,
        },
      }),
    });
    if (response.ok) {
      const data = await response.json();
      setHeadAdmins([...headAdmins, ...[data.head_admin]]);
      setShowHeadAdminModal(false);
    } else {
      if (response.status === 422) {
        const data = await response.json();
        if (data.errors.email) {
          setErrors({ email: ["takenEmail"] });
        }
        return;
      }
      console.log("Error updating head admin");
    }
  };

  const patchHeadAdmin = async () => {
    const response = await fetch("/head_admins/" + headAdmin.id, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
      },
      body: JSON.stringify({
        head_admin: {
          first_name: firstName,
          last_name: lastName,
          email: email,
        },
      }),
    });
    if (response.ok) {
      const data = await response.json();
      setHeadAdmins(
        headAdmins.map((admin) =>
          admin.id == headAdmin.id ? data.head_admin : admin,
        ),
      );
      setShowHeadAdminModal(false);
    } else {
      if (response.status === 422) {
        const data = await response.json();
        if (data.errors.email) {
          setErrors({ email: ["takenEmail"] });
        }
        return;
      }
      console.log("Error updating head admin");
    }
  };

  const onClose = () => {
    setShowHeadAdminModal(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validation = validateAttributes(
      {
        firstName,
        lastName,
        email,
      },
      validations,
    );

    setErrors(validation);

    if (validation) return;

    isEditMode ? patchHeadAdmin() : postHeadAdmin();
  };

  const className = (attribute) => {
    let className = "w-full border border-gray-300 px-3 py-2";
    if (errors && errors[attribute]) {
      className += " border border-red-500 focus:ring-red-500";
    }
    return className;
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white shadow-lg p-6 w-full max-w-lg relative space-y-6">
        <h1 className="font-bold">{label}</h1>
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-black"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <path d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-black mb-1">
              Email
            </label>
            <input
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={className("email")}
            />

            {errorMessage(errors, "email")}
          </div>

          <div>
            <label className="block text-sm font-medium text-black mb-1">
              Imię
            </label>
            <input
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              className={className("firstName")}
            />

            {errorMessage(errors, "firstName")}
          </div>

          <div>
            <label className="block text-sm font-medium text-black mb-1">
              Nazwisko
            </label>
            <input
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              className={className("lastName")}
            />

            {errorMessage(errors, "lastName")}
          </div>

          <button
            type="submit"
            className="flex items-center gap-2 bg-black text-white px-4 py-2"
          >
            Zapisz
          </button>
        </form>
      </div>
    </div>
  );
};

export default HeadAdminModal;

HeadAdminModal.propTypes = {
  headAdmin: PropTypes.object || undefined,
  headAdmins: PropTypes.array,
  setHeadAdmins: PropTypes.func,
  setShowHeadAdminModal: PropTypes.func,
};
